import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import PostShareButton from '../post-share-button';
import share from '../../services/share';
import getOuterUrl from '../../services/get-outer-url';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './post-social-actions.scss';

const containerId = 'post-social-actions';

export class PostSocialActions extends Component {
  handleLinkButtonClick = () => {
    this.props.openShareLinkModal(getOuterUrl(this.props.path), containerId);
  };

  handleShare = socialNetwork => {
    share(socialNetwork, getOuterUrl(this.props.path));
  };

  render() {
    const { t } = this.props;

    return (
      <div
        className={classNames(styles.container, 'forum-text-color', this.props.titleFontClassName)}
        tabIndex="-1"
        id={containerId}
      >
        <div className={styles.content}>
          <span className={styles.button}>
            <PostShareButton type="facebook" title={t('share-button.via-facebook')} onClick={this.handleShare}/>
          </span>
          <span className={styles.button}>
            <PostShareButton type="twitter" title={t('share-button.via-twitter')} onClick={this.handleShare}/>
          </span>
          <span className={styles.button}>
            <PostShareButton type="gPlus" title={t('share-button.via-google-plus')} onClick={this.handleShare}/>
          </span>
          <span className={styles.button}>
            <PostShareButton type="link" title={t('share-button.via-link')} onClick={this.handleLinkButtonClick}/>
          </span>
        </div>
      </div>
    );
  }
}

PostSocialActions.propTypes = {
  path: PropTypes.string.isRequired,
  openShareLinkModal: PropTypes.func.isRequired,
  titleFontClassName: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withFontClassName(withTranslate(PostSocialActions));



// WEBPACK FOOTER //
// ./app/components/post-social-actions/post-social-actions.js